import { useState } from "react";

export function useForceUpdate(): () => void {
    const update = useState(false)[1];
    return (): void => update((s): boolean => !s);
}
